import { type ReactElement } from 'react';
import { maskArea, trafficCamera } from '../LayerFactories';
import { LeafletMap } from '../Map';

import type { Map } from 'leaflet';
import L from 'leaflet';
import type { CameraAreaMapProps } from './types';

export const CameraAreaPageMap = (props: CameraAreaMapProps): ReactElement => {
    const mapProps = props.mapSettings;

    const setupMap = (map: Map): void => {
        if (mapProps.regionExtent) {
            maskArea([mapProps.regionExtent]).addTo(map);
        }

        const cameraLayer = trafficCamera(mapProps.region, props.pageId);
        cameraLayer.addFilter('current-page-cameras', {
            filterFn: (filteredFeatures, allFeatures) => {
                const idsToInclude = props.areaCameras.map((c) => c.pageId);
                return allFeatures.filter((feature) => {
                    return idsToInclude.includes(feature.id as number);
                });
            },
        });

        cameraLayer.addTo(map);

        map.fitBounds(props.areaCameras.map((c) => c.wgs84Position.coordinates.slice().reverse()) as [number, number][], {
            maxZoom: 9,
            padding: L.point(20, 20),
        });
        map.on('moveend', props.onMapZoom, this);
    };

    const unloadMap = (map: Map): void => {
        map.off('moveend', props.onMapZoom, this);
    };

    return <LeafletMap {...mapProps} onMapInitiated={setupMap} onMapUnloaded={unloadMap} />;
};
